import { Delete } from "../../assets/DirectTopUpIcon";
import { cartItems } from "../../data/DemoData";

const CartItems = () => {
  return (
    <div className="w-full">
      <p className="text-lg font-semibold dark:text-white mb-4">Cart Items</p>
      <div className="flex flex-col gap-4 w-full">
        {cartItems.map((item) => (
          <div
            key={item.id}
            className="flex flex-row items-center gap-2 sm:gap-3 w-full"
          >
            <img
              src={item.image}
              alt={item.name}
              className="w-16 h-16 sm:w-20 sm:h-20 bp:w-24 bp:h-24 rounded-md object-cover flex-shrink-0"
            />
            <div className="w-full flex items-center justify-between dark:bg-[#FFFFFF1A] gap-2 border border-border-border1 dark:border-tabs p-2 bp:p-4 rounded-lg">
              <div className="flex flex-col w-full">
                <p className="text-xs bp:text-sm font-semibold text-dark dark:text-white">
                  {item.name}
                </p>
                <p className="text-[8px] bp:text-xs text-gray-400">{`Product: ${item.product}`}</p>
                <div className="flex items-center gap-2 mt-2">
                  <div className="bg-[#039EF2] text-white px-2 py-1 rounded-2xl flex items-center bp:gap-1">
                    <img src="/png/Coins.png" alt="Coins" className="w-4 h-4" />
                    <p className="text-[10px] bp:text-xs font-semibold">
                      {item.coins}
                    </p>
                  </div>
                  <span className="text-xs bp:text-sm text-white">
                    {item.price}
                  </span>
                </div>
              </div>
              <div className="flex flex-col items-center gap-4 flex-shrink-0">
                <Delete />
                <p className="text-black dark:text-white">
                  <span className="font-bold text-xs">{item.quantity}unit</span>
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CartItems;
